export const getOptions = <T, K extends keyof T>(
  array: T[],
  valueField: K,
  labelField: K,
) => {
  return array?.length > 0
    ? array.map(item => {
        return { value: item[valueField], label: item[labelField] };
      })
    : [];
};
